export const environment = {
    production: false,
    title: 'Demo Environment Heading',
    apiURL: 'https://industryxdevhub.demo.accenture.com/ixHub',
    portalURL : 'https://industryxdevhub.demo.accenture.com',
    clientId: '9a18d276-29e9-403e-a21c-a976bd37897c', // This is your client ID
    authority: 'https://login.microsoftonline.com/e0793d39-0939-496d-b129-198edd916feb', // This is your tenant ID
    redirectUri: 'https://industryxdevhub.demo.accenture.com'// This is your redirect URI
};